module.exports = __webpack_public_path__ + "static/media/expandir.69d40ae5.svg";